function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import KwaiImage from './KwaiImage';
import { Platform, Image as RNImage, NativeModules } from 'react-native';
/* global Image */

export const RNImageGetSize = uri => {
  return new Promise((rs, rj) => {
    return RNImage.getSize(uri, (w = 0, h = 0) => {
      rs({
        width: w,
        height: h
      });
    }, error => {
      rj(error);
    });
  });
};
/**
 * @name 获取图标宽高
 * @description 兼容低版本kwaiImage.getSize不存在的问题
 * @description ios14以下且版本小于11.1.10的webp格式的图片会有问题
 * @param uri string
 * @returns (uri: string) => Promise<ImageSizeResponse>
 */

export const getSize = uri => {
  if (Platform.OS === 'web' || typeof NativeModules.KwaiImageView.getSize !== 'function') {
    return RNImageGetSize(uri);
  }

  return KwaiImage.getSize(uri);
};
export const KwaiImageAutoSize = props => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const setSize = useCallback((w, h) => {
    const rate = h ? w / h : w;

    if (props.width && !props.height) {
      setWidth(props.width);
      setHeight(rate ? props.width / rate : 0);
      return;
    }

    if (props.height && !props.width) {
      setHeight(props.height);
      setWidth(rate ? props.height * rate : 0);
      return;
    }

    setWidth(props.width || 0);
    setHeight(props.height || 0);
  }, [props.width, props.height]);
  const computedSize = useCallback(async () => {
    if (typeof props.source !== 'number' && props.source.uri) {
      try {
        const {
          height: h = 0,
          width: w = 0
        } = await getSize(props.source.uri);
        setSize(w, h);
      } catch (error) {
        console.log('uri-getSize', error);
      }
    } else if (typeof props.source !== 'number' && Array.isArray(props.source.uris)) {
      for (const v of props.source.uris) {
        try {
          const {
            height: h = 0,
            width: w = 0
          } = await getSize(v === null || v === void 0 ? void 0 : v.url);
          setSize(w, h); // 成功获取到宽高，不需要继续循环了

          break;
        } catch (error) {
          console.log('uris-getSize', '出错了, 继续循环', error);
        }
      }
    } else {
      if (Platform.OS === 'web') {
        if (typeof props.source === 'string' && props.source) {
          // @ts-ignore
          const img = new Image();
          img.src = props.source;

          img.onload = () => {
            setSize(img.height, img.width);
          };
        }
      } else {
        try {
          const {
            height: h = 0,
            width: w = 0
          } = await KwaiImage.resolveAssetSource(props.source);
          setSize(w, h);
        } catch (error) {
          console.log('getSize', error);
        }
      }
    }
  }, [props.source, setSize]);
  useEffect(() => {
    computedSize();
  }, [computedSize]);
  const sizeStyle = useMemo(() => {
    if (width && height) {
      return {
        width,
        height
      };
    }

    return {};
  }, [width, height]);
  return /*#__PURE__*/React.createElement(KwaiImage, _extends({}, props, {
    style: [props.style, { ...sizeStyle
    }]
  }));
};
export default KwaiImageAutoSize;
//# sourceMappingURL=KwaiImageAutoSize.js.map